var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2314,
    height: 1504,
    viewBox: "0 0 2314 1504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2314,
    height: 1504
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2314,
    height: 1504,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-702 940.581C-535.67 775.086 1047.13 -257.882 1210.62 299.526C1349.46 772.836 -57.5987 1755.08 93.0452 1207.55C230.122 709.325 958.754 876.212 1005.82 898.071C1070.5 928.116 1119.95 928.116 1407 928.116C1694.05 928.116 1789.57 -57.5605 2208.87 241.712C2628.16 540.985 2633 1171.84 3187.75 1207.55C3742.51 1243.25 3936.03 282.522 3815.08 241.712C3694.13 200.902 3319.99 1013.7 3957 1141.23C4466.6 1243.25 4746.67 1292.57 4823 1304.47",
    stroke: "#FAF7F5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMask);
export default __webpack_public_path__ + "static/media/Mask.82af691888d718aacac263d62c2d8f09.svg";
export { ForwardRef as ReactComponent };